//
// AUTO-GENERATED FILE. DO NOT MODIFY.
//
// This class was automatically generated by Apollo GraphQL version '5.2.0'.
//
package blazern.lexisoup.graphql.model.selections

import blazern.lexisoup.graphql.model.type.GraphQLString
import blazern.lexisoup.graphql.model.type.Query
import blazern.lexisoup.graphql.model.type.TranslationResult
import com.apollographql.apollo.api.CompiledArgument
import com.apollographql.apollo.api.CompiledField
import com.apollographql.apollo.api.CompiledSelection
import com.apollographql.apollo.api.CompiledVariable
import com.apollographql.apollo.api.list
import com.apollographql.apollo.api.notNull
import kotlin.collections.List

public object TranslateQuerySelections {
  private val __translate: List<CompiledSelection> = listOf(
        CompiledField.Builder(
          name = "translations",
          type = GraphQLString.type.notNull().list().notNull()
        ).build(),
        CompiledField.Builder(
          name = "source",
          type = GraphQLString.type.notNull()
        ).build()
      )

  public val __root: List<CompiledSelection> = listOf(
        CompiledField.Builder(
          name = "translate",
          type = TranslationResult.type.notNull()
        ).arguments(listOf(
          CompiledArgument.Builder(Query.__translate_langFromIso3).value(CompiledVariable("langFromIso3")).build(),
          CompiledArgument.Builder(Query.__translate_langToIso3).value(CompiledVariable("langToIso3")).build(),
          CompiledArgument.Builder(Query.__translate_texts).value(CompiledVariable("texts")).build()
        ))
        .selections(__translate)
        .build()
      )
}
